class DiscountProgressWidget {
  constructor() {
    document.addEventListener("CartFetched",(event)=>{
      this.update_discount_progress(event.detail);
    });
  }

  update_discount_progress(cart) {
    document.querySelectorAll(".js-discount-progress").forEach((widget)=>{
      var subscriptions = widget.querySelector('[data-progress-subscription]');
      var onetimes = widget.querySelector('[data-progress-onetimes]');
      
      subscriptions.setAttribute('hidden','');
      if (widget.getAttribute("data-progress-context")=="pdp") {
        if (widget.getAttribute("data-progress-show")=="autodeliver") {
          if (widget.hasAttribute("data-hide")) {
          	widget.setAttribute("hidden","");
    	  } else {
        	widget.removeAttribute("hidden");
       	  }
          this.update_discount_subscriptions(subscriptions,cart);
        } else {
          widget.setAttribute("hidden","");
          //this.update_discount_onetimes(onetimes,cart);
        }
      } else {
        this.update_discount_subscriptions(subscriptions,cart);
      }
    });
    var shipping_threshold = 3500;
    var shipping_price
    var shipping_container = document.querySelector(".go-cart-drawer__shipping-price");
    
    var shipping_master_override = false;
    var free_shipping_ids = [6688196821094,6688196395110];
    window.cart.items.forEach(item=>{
      if (free_shipping_ids.includes(item.product_id)) {
        shipping_master_override = true;
      }
    });
    
    if (window.cart.total_price>=shipping_threshold || shipping_master_override) {
      shipping_container.innerHTML = "FREE";
    } else {
      shipping_container.innerHTML = "$7.95";
    }
    
  }

  update_discount_subscriptions(element,cart) {
    element.removeAttribute("hidden");
    var item_count = 0;
    
    cart.items.forEach(item=>{
      if (item.selling_plan_allocation) {
        item_count+=item.quantity;
      }
    });

    window.sub_item_count = item_count;
    
    var discount = 15;
    var goal=3;
    var display_percent = 0;
    var prior_discount=0;
    if (item_count<3) {
      goal=3;
      	display_percent=0;
    } else if (item_count>=3 && item_count<6) {
      goal = 6;
      discount = 25;
      prior_discount=15;
      display_percent = 25;
    } else if (item_count>=6 && item_count<10) {
      goal = 10;
      discount = 30;
      prior_discount = 25;
      display_percent=80;
    } else {
      display_percent = 99;
      discount=30;
      prior_discount = 30;
    }
    
    var actual_display_percent = (((item_count*5)/60)*100)+((item_count>1)?12:0);
    if (actual_display_percent > 100) { actual_display_percent=100; }
    // console.error(display_percent);

    var discount_text='';
    var shortfall = goal-item_count;
    
    if (shortfall==1) {
      element.querySelectorAll(".is_plural").forEach(text=>text.setAttribute("hidden",""));
    } else {
      element.querySelectorAll(".is_plural").forEach(text=>text.removeAttribute("hidden"));
    }

    element.querySelectorAll(".discount-step").forEach(step=>step.classList.remove("active"));

    element.querySelector(".js-progress-visual").style.width = `${actual_display_percent}%`;
    if (item_count>0) {
    	document.querySelectorAll('[data-display-percent]').forEach(step=>{
     	 	if (parseInt(step.getAttribute("data-display-percent"))<=display_percent) {
        		step.classList.add("active");
      		}
    	});
    }
    
    element.querySelectorAll("#discount_packs_remaining").forEach(text=>text.innerHTML=shortfall);
    element.querySelector(".js-discount-upsell").querySelector("#discount_packs_discount").innerHTML=discount;
    var ship_text = element.querySelector(".discount-ship-text"); 
    if (prior_discount>0) {
      ship_text.querySelector("#discount_packs_discount").innerHTML=prior_discount;
      ship_text.classList.add("active");
    } else {
      if (ship_text.classList.contains("active")) { ship_text.classList.remove("active"); }
      ship_text.querySelector("#discount_packs_discount").innerHTML=discount;
    }
    var bottom_text = element.querySelector(".lower-upsell");
    if (discount==prior_discount || item_count<3) {
      bottom_text.classList.add("active");
    } else {
      bottom_text.classList.remove("active");
    }
  }

  update_discount_onetimes(element,cart) {
    element.removeAttribute("hidden");
    var item_count = cart.item_count;
    var goal=3;
    var display_percent = 0;
    switch(item_count) {
      case 0:
        break;
      case 1:
        display_percent=1;
        break;
      case 2:
        display_percent=50;
        break;
      case 3:
        display_percent=99;
        break;
      default:
        display_percent=99;
        break;
    }
    var shortfall = goal-item_count;

    if (shortfall==1) {
      element.querySelectorAll(".is_plural").forEach(text=>text.setAttribute("hidden",""));
    } else {
      element.querySelectorAll(".is_plural").forEach(text=>text.removeAttribute("hidden"));
    }
    
    element.querySelectorAll(".discount-step").forEach(step=>step.classList.remove("active"));
    
    element.querySelector(".js-progress-visual").style.width=`${display_percent}%`;
    if (item_count>0) {
      for (var i=1;i<=display_percent;i+=49) {
        element.querySelector(`[data-display-percent='${i}']`).classList.add("active");
      }
    }
    element.querySelectorAll(".discount-announce").forEach(text=>text.setAttribute("hidden",""));
   
    if (shortfall<=0) {
      element.querySelectorAll(".goal-reached").forEach(announce=>{
        announce.removeAttribute("hidden");
        announce.classList.add("active");
      });
    } else {
       element.querySelectorAll(".goal-reached").forEach(announce=>{
        announce.setAttribute("hidden","");
        announce.classList.remove("active");
      });
      element.querySelectorAll(".goal-add").forEach(announce=>announce.removeAttribute("hidden"))
    }
    element.querySelectorAll("#discount_packs_remaining").forEach(text=>text.innerHTML=shortfall);
  }

  toggle_pdp(product_id,type) {
    var widget = document.querySelector(`[data-progress-product='${product_id}']`);
    widget.setAttribute("data-progress-show",type);
    this.update_discount_progress(window.cart);
  }
}

window.discountProgressWidget = new DiscountProgressWidget()
